import { Injectable } from '@angular/core'
import { SajuLogEvent } from 'src/app/interfaces/log/saju-log'
import { SocialShareType } from 'src/app/interfaces/main'
import { DohwaType } from 'src/app/interfaces/saju'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class SajuLogService {
  constructor(private logService: LogService) {}

  logHomeSajuBannerImpressed(hasSaju: boolean) {
    this.logService.eventLogging(SajuLogEvent.HOME_SAJU_BANNER_IMPRESSED, { hasSaju })
  }
  logHomeSajuBannerClicked() {
    this.logService.eventLogging(SajuLogEvent.HOME_SAJU_BANNER_CLICKED)
  }
  logSajuLandingViewed() {
    this.logService.eventLogging(SajuLogEvent.SAJU_LANDING_VIEWED)
  }
  // [사주 일주 분석 랜딩]버튼 클릭
  logSajuLandingDohwaStartButtonClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_LANDING_DOHWA_START_BUTTON_CLICKED)
  }
  logSajuInputViewed(type: 'name' | 'birth_date' | 'birth_time' | 'gender' | 'birth_region') {
    this.logService.eventLogging(SajuLogEvent.SAJU_INPUT_VIEWED, { type })
  }
  logSajuInputNextButtonClicked(type: 'name' | 'birth_date' | 'birth_time' | 'gender' | 'birth_region') {
    this.logService.eventLogging(SajuLogEvent.SAJU_INPUT_NEXT_BUTTON_CLICKED, { type })
  }
  logSajuInputDontKnowButtonClicked(type: 'name' | 'birth_date' | 'birth_time' | 'gender' | 'birth_region') {
    this.logService.eventLogging(SajuLogEvent.SAJU_INPUT_DONT_KNOW_BUTTON_CLICKED, { type })
  }
  logSajuResultViewed() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_VIEWED)
  }
  logSajuResultTestResultClicked(title: string) {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_TEST_RESULT_CLICKED, { title })
  }
  logSajuResultVoteButtonClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_VOTE_BUTTON_CLICKED)
  }
  logSajuResultAddFriendButtonClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_ADD_FRIEND_BUTTON_CLICKED)
  }
  logSajuResultFriendClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_FRIEND_CLICKED)
  }
  logDohwasalLandingScreenViewed() {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_LANDING_SCREEN_VIEWED)
  }
  logDohwasalLandingCardClicked(type: DohwaType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_LANDING_CARD_CLICKED, { type })
  }
  logDohwasalLandingInstaStoryShared() {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_LANDING_INSTA_STORY_SHARED)
  }
  logDohwasalLandingShareButtonClicked(type: SocialShareType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_LANDING_SHARE_BUTTON_CLICKED, { type })
  }
  logDohwasalLandingImageSaved() {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_LANDING_IMAGE_SAVED)
  }
  logDohwasalLandingOtherFeatureCardClicked(type: DohwaType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_LANDING_OTHER_FEATURE_CARD_CLICKED, { type })
  }
  logDohwasalDetailScreenViewed(type: DohwaType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_DETAIL_SCREEN_VIEWED, { type })
  }
  logDohwasalDetailInstaStoryShared(type: DohwaType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_DETAIL_INSTA_STORY_SHARED, { type })
  }
  logDohwasalDetailImageSaved(type: DohwaType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_DETAIL_IMAGE_SAVED, { type })
  }
  logDohwasalDetailShareButtonClicked(type: SocialShareType) {
    this.logService.eventLogging(SajuLogEvent.DOHWASAL_DETAIL_SHARE_BUTTON_CLICKED, { type })
  }
  // [사주 결과 선택] 화면 진입
  logSajuResultSelectionViewed() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_SELECTION_VIEWED)
  }
  // [사주 결과 선택] 결과 클릭
  logSajuResultSelectionResultClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_SELECTION_RESULT_CLICKED)
  }
  // [사주 결과 선택] 새로 진행하기 클릭
  logSajuResultSelectionCreateClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_SELECTION_CREATE_CLICKED)
  }
  // [사주 결과 선택] 앱 설치 클릭
  logSajuResultSelectionAppInstallClicked() {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_SELECTION_APP_INSTALL_CLICKED)
  }
  // [사주 결과]사주 배너 아이템 클릭
  logSajuResultSajuBannerItemClicked(type: 'deep-analysis' | 'year-analysis' | 'chemi-analysis') {
    this.logService.eventLogging(SajuLogEvent.SAJU_RESULT_SAJU_BANNER_ITEM_CLICKED, { type })
  }
  // [사주 일주 분석 랜딩]화면 진입
  logDayPillarAnalysisLandingScreenViewed() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_LANDING_SCREEN_VIEWED)
  }
  // [사주 일주 분석 랜딩]버튼 클릭
  logDayPillarAnalysisLandingButtonClicked() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_LANDING_BUTTON_CLICKED)
  }
  // [사주 일주 분석 MBTI 선택]화면 진입
  logDayPillarAnalysisMbtiSelectScreenViewed(isAnonymous: boolean) {
    // isUpdating -> APP ONLY
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_MBTI_SELECT_SCREEN_VIEWED, {
      isAnonymous,
      isUpdating: false,
    })
  }
  // [사주 일주 분석 MBTI 선택]아이템 클릭
  logDayPillarAnalysisMbtiSelectItemClicked(isAnonymous: boolean) {
    // isUpdating -> APP ONLY
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_MBTI_SELECT_ITEM_CLICKED, {
      isAnonymous,
      isUpdating: false,
    })
  }
  // [사주 일주 분석 MBTI 선택]만들기 클릭
  logDayPillarAnalysisMbtiSelectCreateClicked() {
    // isUpdating -> APP ONLY
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_MBTI_SELECT_CREATE_CLICKED, {
      isUpdating: false,
    })
  }
  // [사주 일주 분석 로딩]화면 진입
  logDayPillarAnalysisLoadingScreenViewed() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_LOADING_SCREEN_VIEWED)
  }
  // [사주 일주 분석 로딩]앱 버튼 노출
  logDayPillarAnalysisLoadingAppButtonViewed() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_LOADING_APP_BUTTON_VIEWED)
  }
  // [사주 일주 분석 로딩]앱 버튼 클릭
  logDayPillarAnalysisLoadingAppButtonClicked() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_LOADING_APP_BUTTON_CLICKED)
  }
  // [사주 일주 분석 결과]화면 진입
  logDayPillarAnalysisResultScreenViewed() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_RESULT_SCREEN_VIEWED)
  }
  // [사주 일주 분석 결과]공유 버튼 클릭
  logDayPillarAnalysisResultShareButtonClicked(type: SocialShareType) {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_RESULT_SHARE_BUTTON_CLICKED, { type })
  }
  // [사주 일주 분석 결과]MBTI 바꾸기 버튼 클릭
  logDayPillarAnalysisResultUpdateMbtiButtonClicked() {
    this.logService.eventLogging(SajuLogEvent.DAY_PILLAR_ANALYSIS_RESULT_UPDATE_MBTI_BUTTON_CLICKED)
  }
}
